import { HTMLAttributes, useEffect, useRef } from 'react'

type SVGIconProps = HTMLAttributes<SVGSVGElement> & { symbol?: string }

const SVGIcon = ({ symbol, ...props }: SVGIconProps) => {
  const svgRef = useRef<SVGSVGElement>(null)

  useEffect(() => {
    if (svgRef.current && symbol) {
      const symbolEl = document.querySelector(`#${symbol}`) as SVGSymbolElement
      if (symbolEl) {
        const viewBox = symbolEl.getAttribute('viewBox')
        const width = symbolEl.getAttribute('width')
        const height = symbolEl.getAttribute('height')

        if (viewBox) svgRef.current.setAttribute('viewBox', viewBox)
        if (width) svgRef.current.setAttribute('width', width)
        if (height) svgRef.current.setAttribute('height', height)
      }
    }
  }, [symbol])

  return (
    <svg ref={svgRef} {...props}>
      <use xlinkHref={`#${symbol}`} />
    </svg>
  )
}

export default SVGIcon
